import { Button, Form, NumberBox, Popup, TextArea, TextBox } from 'devextreme-react';
import { ButtonItem, EmptyItem, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import { SelectBox, Item as SbItem } from 'devextreme-react/select-box';
import { Component } from 'react';
import TablesTree from './TablesTree';
import { UniGrid } from '../UniGrid';
import Inline from '../Inline';

function findTypeOfDataGate(dg, acct) {
    acct ??= [1, 2, 3];

    if (acct?.length === 1)
        return acct[0];

    if (!dg)
        return null;

    if (acct.includes(2) && dg.table?.length > 0)
        return 2;

    if (acct.includes(3) && dg.baseCrudUrl?.length > 0)
        return 3;

    if (acct.includes(1) && (dg.records?.length > 0 || dg.record != null || dg.record != undefined))
        return 1;

    return null;
}

class DataGateProps extends Component {
    state = {
        dataGate: this.props.dataGate ?? {},
        type: findTypeOfDataGate(this.props.dataGate, this.props.acceptableTypes),
        records: this.props.dataGate?.records ?? [],
        record: { id: '', summary: '' },
        recordsKey: 1,
    }

    set = updater => {
        updater(this.state.dataGate);
        this.forceUpdate();
    }

    onTypeChanged = t => {
        this.state.type = t;

        if (t === 1) {
            this.state.dataGate.table = '';
            this.state.dataGate.baseCrudUrl = '';
        }
        else if (t === 2) {
            this.state.dataGate.record = '';
            this.state.dataGate.records = '';
            this.state.dataGate.baseCrudUrl = '';
        }
        else if (t === 3) {
            this.state.dataGate.record = '';
            this.state.dataGate.records = '';
            this.state.dataGate.table = '';
        }

        this.forceUpdate();
    }

    componentDidMount() {
    }

    render() {
        let dg = this.state.dataGate;
        //console.log('~~~~~ ', dg);

        return (
            <>
                <Form colCount={60} rtlEnabled width='65rem' key={'frm_' + this.state.type}
                >
                    <GroupItem colSpan={35} colCount={60}>
                        <SimpleItem colSpan={30}>
                            <Label text='جریان داده' />
                            <SelectBox valueExpr='val' displayExpr='text' rtlEnabled
                                value={dg.flowDirection ?? 0} onValueChanged={e => this.set(dg => dg.flowDirection = e.value)}
                            >
                                <SbItem text='سرور به کلاینت' val={1} />
                                <SbItem text='کلاینت به سرور' val={2} />
                                <SbItem text='دوطرفه' val={0} />
                            </SelectBox>
                        </SimpleItem>

                        <SimpleItem colSpan={30} rtlEnabled>
                            <Label text='نوع' />
                            <SelectBox valueExpr='val' displayExpr='text' rtlEnabled
                                value={this.state.type} onValueChanged={e => this.onTypeChanged(e.value)}
                            >
                                {(!(this.props.acceptableTypes?.length > 0) || this.props.acceptableTypes.includes(1)) && <SbItem text='ایستا' val={1} />}
                                {(!(this.props.acceptableTypes?.length > 0) || this.props.acceptableTypes.includes(2)) && <SbItem text='جدول' val={2} />}
                                {(!(this.props.acceptableTypes?.length > 0) || this.props.acceptableTypes.includes(3)) && <SbItem text='آدرس' val={3} />}
                            </SelectBox>
                        </SimpleItem>

                        {this.state.type === 2 &&
                            <SimpleItem colSpan={60}>
                                <Label text='WHERE phrase' />
                                <TextArea rtlEnabled={false} className='mdh-left-align'
                                    value={dg.wherePhrase} onValueChanged={e => this.set(dg => dg.wherePhrase = e.value)}
                                />
                            </SimpleItem>
                        }

                        <SimpleItem colSpan={60}>
                            <Label text='فیلتر (جاواسکریپت)' />
                            <TextArea rtlEnabled={false} className='mdh-left-align' //placeholder='() => true'
                                value={dg.jsFilter} onValueChanged={e => this.set(dg => dg.jsFilter = e.value)}
                            />
                        </SimpleItem>

                        {this.props.hideJsMapping !== true &&
                            <SimpleItem colSpan={60}>
                                <Label text='نگاشت (جاواسکریپت)' />
                                <TextArea rtlEnabled={false} className='mdh-left-align' //placeholder='row => row'
                                    value={dg.jsMap} onValueChanged={e => this.set(dg => dg.jsMap = e.value)}
                                />
                            </SimpleItem>
                        }
                    </GroupItem>

                    <GroupItem colSpan={25} colCount={3}
                    >
                        {this.state.type === 1 &&
                            <Inline spacing='5px' style={{ width: '100%', margin: '0 0 5px 0' }}>
                                <Button text='افزودن' icon='plus' width='33.33%' type='success'
                                    onClick={() => this.setState({ record: { id: '', summary: '', orgId: 0 }, recordPopVisible: true })}
                                />
                                <Button text='ویرایش' icon='edit' width='33.33%' type='success'
                                    onClick={() => this.setState({ recordPopVisible: true })}
                                />
                                <Button text='حذف' icon='trash' width='33.33%' type='danger'
                                    onClick={() => this.setState({
                                        records: [...this.state.records.filter(x => x.id !== this.state.record.id)],
                                        recordsKey: this.state.recordsKey + 1
                                    })}
                                />
                            </Inline>
                        }

                        {this.state.type === 1 &&
                            <UniGrid key={`srgrid_${this.state.recordsKey}`}
                                noMetaGrid readOnly columns={[{ name: 'id', caption: 'آیدی' }, { name: 'summary', caption: 'متن' }]}
                                rows={this.state.records} noToolbar sequenceColumn={false} filterRow={false}
                                onFocusedRowChanged={sr => this.setState({ record: { id: sr.id, summary: sr.summary, orgId: sr.id } })}
                            />
                        }
                        {this.state.type === 2 &&
                            <TablesTree height={300} width='100%' rtlEnabled={false} formBased //key={'tbltree_' + dg.table}
                                focusedTableName={dg.table}
                                onFocusedTableChanged={t => this.set(dg => dg.table = t?.tableName)}
                            />
                        }
                        {this.state.type === 3 &&
                            <SimpleItem colSpan={3}>
                                <Label text='CRUD base url' location='top' />
                                <TextArea rtlEnabled={false} className='mdh-left-align' minHeight='9rem' height='100%'
                                    value={dg.baseCrudUrl} onValueChanged={e => this.set(dg => dg.baseCrudUrl = e.value)}
                                />
                            </SimpleItem>
                        }
                    </GroupItem>

                    <EmptyItem colSpan={60} />

                    <ButtonItem colSpan={15} buttonOptions={{
                        text: 'قبول', icon: 'check', width: '90%', type: 'success',
                        onClick: () => {
                            if (this.state.type === 1)
                                dg.records = this.state.records;

                            this.props.onOk(dg)
                        }
                    }}
                    />

                    <ButtonItem colSpan={15} buttonOptions={{
                        text: 'رد', icon: 'close', width: '90%', type: 'danger',
                        onClick: () => this.props.onCancel()
                    }}
                    />
                </Form >

                <Popup title='رکورد' visible={this.state.recordPopVisible} showCloseButton width='auto' height='auto'
                    onHidden={() => this.setState({ recordPopVisible: false })} rtlEnabled
                >
                    <Form rtlEnabled colCount={60} width='30rem'>
                        <SimpleItem colSpan={60}>
                            <Label text='آیدی' />
                            <NumberBox
                                value={this.state.record.id}
                                onValueChanged={e => { this.state.record.id = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>

                        <SimpleItem colSpan={60}>
                            <Label text='متن' />
                            <TextBox rtlEnabled
                                value={this.state.record.summary}
                                onValueChanged={e => { this.state.record.summary = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <ButtonItem colSpan={30}
                            buttonOptions={{
                                text: 'قبول', icon: 'check', width: '90%', type: 'success',
                                onClick: () => {
                                    let { id, summary, orgId } = this.state.record;
                                    this.setState({
                                        records: orgId > 0
                                            ? [...this.state.records.filter(x => x.id !== orgId), { id, summary }]
                                            : [...this.state.records, { id, summary }],
                                        recordsKey: this.state.recordsKey + 1,
                                        recordPopVisible: false,
                                    });
                                }
                            }}
                        />

                        <ButtonItem colSpan={30}
                            buttonOptions={{
                                text: 'رد', icon: 'close', width: '90%', type: 'danger',
                                onClick: () => this.setState({ recordPopVisible: false })
                            }}
                        />
                    </Form>
                </Popup>
            </>
        );
    }
}

export default DataGateProps;
